// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] + "-" + {"532":"9358739d364dae5d8443","678":"7f5184650ea31165b18e","774":"752bba9200ab6b83df84"}[chunkId] + ".js";
};